import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale/ko";

const YearPicker = ({setRequestData}) => {
  const [startDate, setStartDate] = useState(new Date());
  const onChangeYear = (date) => {
    setStartDate(date);
    setRequestData(prev => ({
      ...prev,
      YDATE: date.getFullYear()
    }));
  }
  return(
    <DatePicker
      className="min-h-6 max-w-24 text-sm px-1 border border-black bg-yellow-100"
      selected={startDate}
      onChange={(date) => onChangeYear(date)}
      selectsStart
      locale={ko}
      startDate={startDate}
      showYearPicker
      dateFormat="yyyy"
      yearItemNumber={6}
    />
  )
}

export default YearPicker;